import { tap, mergeMap } from 'rxjs/operators';
import { Router } from '@angular/router';

import { ConfigService } from 'src/app/shared/services/config/config.service';
import { initAuthentication } from '../init-authentication/init-authentication';
import { LocalStorageService } from '@shared/services/local-storage/local-storage.service';
import { initCulture } from './init-culture';
import { initPropeller } from './init-propeller';
import { AuthService } from '@shared/services/auth/auth.service';

export function AppInitializerFactory(
  configService: ConfigService,
  auth: AuthService,
  router: Router,
  localStorageService: LocalStorageService
): () => Promise<any> {
  return (): Promise<any> => {
    return configService
      .getConfig()
      .pipe(
        tap(() => initPropeller(configService)),
        tap(() => initCulture(configService, localStorageService)),
        mergeMap(() => initAuthentication(auth, router))
      )
      .toPromise();
  };
}
